<template>
    <div
        :class="{'form-group':true, 'has-error':error !== ''}"
    >
        <label v-if="label" class="control-label" :for="id">{{ label }}:</label>
        <div class="callout callout-info"
            v-if="hasCalloutInfoSlot"
        >
            <slot name="callout-info"></slot>
        </div>
        <input
            :id="id"
            ref="input"
            v-bind="$attrs"
            class="form-control"
            :type="type"
            :value="value"
            :placeholder="placeholder"
            :maxlength="maxlength"
            @input="$emit('input', $event.target.value)"
            @keyup.enter="$emit('onEnter')"
        />
        <small v-if="error === '' && description !== null" class="help-block" v-text="description"></small>
        <span v-if="error !== ''" class="help-block">{{ error }}</span>
    </div>
</template>

<script>

export default {

    /*
        Slots:

        - callout-info: <template v-slot:callout-info></template>
     */

    computed: {
        hasCalloutInfoSlot() {
            return !!this.$slots['callout-info'];
        },
    },

    inheritAttrs:false,

    methods:{
        focusField(){
            this.$refs.input.focus()
        },
    },

    mounted() {
        if (this.focus === true) {
            setTimeout(() => this.focusField(), 200);
        }
    },

    props:{
        description:{
            type:String,
            default:null,
        },
        error:{
            type:String,
            default:'',
        },
        focus:{
            type:Boolean,
            default:false,
        },
        id:{
            type:String,
            default(){
                return `text-input-${this._uid}`
            },
        },
        label:{
            required:true,
            type:String,
        },
        maxlength: {
            type:Number,
            default:524288,
        },
        placeholder:{
            type:String,
            default:"",
        },
        type:{
            type:String,
            default:'text',
        },
        value:{
            default:'',
        },
    },
}

</script>
